export const HEADERS = ["name", "notification text", "actions"];

// Appointment resources show which services they perform instead of the notification
// text, which the appointments flow does not use.
export const APPOINTMENT_HEADERS = ["name", "Services Offered", "actions"];

export const ACTIONS = [
  {
    name: "edit",
    className: "mdi mdi-account-edit-outline",
    color: "#016BFF"
  },
  {
    name: "delete",
    className: "mdi mdi-delete-outline",
    color: "#6F6F6F"
  }
];
